import { useAppSignUpPageResultsUpdateEffect } from "@faire/retailer-visitor-shared/components/AppSignUp/AppSignUpPageResultsProvider";
import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { NoResultsContainer } from "@faire/retailer-visitor-shared/components/NoResults/index";
import { useLoggedOutSuppliersPageCurrentCategory } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/Context/useLoggedOutSuppliersPageCurrentCategory";
import { useLoggedOutSuppliersPageBrandSearchResults } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageBrandSearchResults";
import { useLoggedOutSuppliersPageIsPending } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPageIsLoading";
import { FilmstripBrandList } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageFilmStripBrandList/__internal__/FilmstripBrandList/FilmstripBrandList";
import { useLoggedOutSuppliersPageQueryParams } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/QueryParams/useLoggedOutSuppliersPageQueryParams";
import { FilmstripBrandListSkeleton } from "@faire/retailer-visitor-shared/views/suppliers/SuppliersPageLoadingSkeleton/FilmstripBrandListSkeleton";
import React from "react";

interface IProps {
  loadTimingRef?: React.Ref<HTMLDivElement>;
}

export const LoggedOutSuppliersPageFilmStripBrandList: React.FC<IProps> = ({
  loadTimingRef,
}) => {
  const brandSearchResults = useLoggedOutSuppliersPageBrandSearchResults();
  const isLoading = useLoggedOutSuppliersPageIsPending();
  const categoryModel = useLoggedOutSuppliersPageCurrentCategory();
  const { clearFilters } = useLoggedOutSuppliersPageQueryParams();
  const {
    data: { activeFilterCount },
  } = useFilterStore(["activeFilterCount"]);

  useAppSignUpPageResultsUpdateEffect({
    suppliersPageBrands: brandSearchResults,
  });

  if (isLoading) {
    return <FilmstripBrandListSkeleton />;
  }

  if (!brandSearchResults || brandSearchResults.length === 0) {
    return (
      <NoResultsContainer
        showProductFirstResults={false}
        hasFiltersApplied={activeFilterCount > 0}
        onClearFilters={clearFilters}
        divRef={loadTimingRef}
      />
    );
  }

  return (
    <FilmstripBrandList
      brands={brandSearchResults}
      categoryPathIdentifier={categoryModel.pathIdentifier ?? ""}
      loadTimingRef={loadTimingRef}
    />
  );
};
